/** 通用 */
import request from "@/utils/request"

/** 上传 */
export function upload(param) {
  return request({
    headers: {
      "Content-Type": "multipart/form-data"
    },
    url: "/upload",
    method: "post",
    data: param
  })
}

/** 订单详情 */
export function orderDetail(orderId) {
  return request({
    url: `/detail`,
    method: "get",
    params: {
      order_id: orderId
    }
  })
}

/** 申报状态 */
export function orderStatus(orderType, subType) {
  return request({
    url: `/order_status`,
    method: "get",
    params: {
      order_type: orderType,
      sub_type: subType
    }
  })
}
